import { createFileRoute, Link } from "@tanstack/react-router";
import useTranslation from "../../hooks/useTranslation";
import { GenerateTextMockupSection } from "./generate_text_mockup";
import { ReadAloudMockupSection } from "./read_aloud_mockup";

export const Route = createFileRoute("/app/feature_mockups")({
  component: FeatureMockupsPage,
});

function FeatureMockupsPage() {
  const { translate } = useTranslation();

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-5 sm:px-6">
      <section className="rounded-[26px] border border-slate-200 bg-white px-5 py-5 sm:px-6">
        <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
          {translate("feature_mockups_eyebrow")}
        </p>
        <h1 className="mt-3 font-serif text-3xl text-slate-900 sm:text-4xl">
          {translate("feature_mockups_title")}
        </h1>
        <p className="mt-3 max-w-3xl text-base leading-relaxed text-slate-700">
          {translate("feature_mockups_subtitle")}
        </p>
      </section>

      <div className="mt-6 rounded-[26px] border border-slate-200 bg-white px-2 py-2 sm:px-3 sm:py-3">
        <GenerateTextMockupSection />
      </div>

      <div className="mt-6 rounded-[26px] border border-slate-200 bg-white px-2 py-2 sm:px-3 sm:py-3">
        <ReadAloudMockupSection />
      </div>

      <div className="mt-6 rounded-[26px] border border-slate-200 bg-white px-5 py-5 sm:px-6">
        <p className="text-[11px] uppercase tracking-[0.18em] text-slate-500">
          In-App Mockup
        </p>
        <h2 className="mt-1.5 font-serif text-xl text-slate-900">
          {translate("feature_mockups_vocabulary_composer_title")}
        </h2>
        <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-slate-600">
          {translate("feature_mockups_vocabulary_composer_subtitle")}
        </p>
        <Link
          to="/app/vocabulary_composer_mockup"
          className="mt-3 inline-block rounded-full border border-slate-300 bg-white px-4 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
        >
          Open mockup &rarr;
        </Link>
      </div>
    </div>
  );
}
